import { createFeatureSelector, createSelector } from '@ngrx/store';

/** Must stay in sync with NOTIFICATIONS_COUNT_FEATURE_KEY in notifications/drawer/lazy. */
const NOTIFICATIONS_COUNT_FEATURE_KEY = 'notificationsCount';

interface NotificationsCountState {
  unreadCount: number;
  loading: boolean;
}

const selectNotificationsCountState = createFeatureSelector<NotificationsCountState>(NOTIFICATIONS_COUNT_FEATURE_KEY);

/** Unread notification count for the bell badge in the top nav. */
export const selectNotificationBellCount = createSelector(selectNotificationsCountState, state => state.unreadCount);
